<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

    <div>
        <modal size="medium"
               v-show="bankAccount != null"
               id="ModalBankAccount">

            <template v-slot:header>
                <h3 class="title">Conta Bancária</h3>
            </template>

            <template v-slot:body>
                <div class="container-fluid-grid" v-if="bankAccount">
                    <div class="form-row">
                        <div class="col-9 form-group">
                            <label for="bankAccountId" class="required">Banco</label>
                            <select v-model="bankAccount.bank_id"
                                    id="bankAccountId"
                                    required
                                    class="form-control form-control-sm"
                                    :class="{'is-invalid': errors.bank_id}">
                                <option v-for="b in banks"
                                        :key="b.id"
                                        :value="b.id">{{b.code}} - {{b.name}}</option>
                            </select>
                            <field-messages :errors="errors.bank_id"/>
                        </div>
                        <div class="col-3 form-group">
                          <label class="required">Conta padrão?</label>
                          <div class="checkbox-inline" style="padding: 5px">
                            <label>
                              <input type="checkbox"
                                     v-model="bankAccount.is_default"
                                     @change="bankAccount.is_default !== bankAccount.is_default"
                                     class="checkbox seller m"/>
                            </label>
                          </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-6 form-group">
                            <label for="bankAccountAgency" class="required">Agência</label>
                            <input type="text"
                                   id="bankAccountAgency"
                                   required
                                   autocomplete="off"
                                   maxlength="20"
                                   class="form-control form-control-sm"
                                   :class="{'is-invalid': errors.agency}"
                                   v-model="bankAccount.agency"
                            />

                            <field-messages :errors="errors.agency"/>
                        </div>
                        <div class="col-6 form-group">
                            <label for="bankAccountNumber" class="required">Conta</label>
                            <input type="text"
                                   id="bankAccountNumber"
                                   required
                                   autocomplete="off"
                                   maxlength="20"
                                   class="form-control form-control-sm"
                                   :class="{'is-invalid': errors.number}"
                                   v-model="bankAccount.number"
                            />
                            <field-messages :errors="errors.number"/>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:footer>
                <button type="button"
                        @click="save"
                        class="btn btn-sm btn-theme-1">
                    <svg-icon icon="save"/>
                    Salvar
                </button>
                <button type="button"
                        @click="bankAccount = null"
                        class="btn btn-sm btn-dark">
                    <svg-icon icon="times"/>
                    Fechar
                </button>
            </template>
        </modal>

        <div class="container-fluid-grid" v-if="$appUtils.isDesktop()">
            <div class="row">
                <div class="col-12">
                    <table class="table table-bordered table-hover table-striped table-sm">
                        <thead class="thead-dark thead-center">
                        <tr>
                            <th>Banco</th>
                            <th>Agência</th>
                            <th>Conta</th>
                            <th>Conta padrão?</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(a,idx) in entity.customer_accounts_attributes"
                            :key="`${a.bank.id}${idx}`"
                            class="line-item">
                            <td class="ellipsis c-p" @click="edit(a)">{{a.bank.code}} - {{a.bank.name}}</td>
                            <td class="ellipsis c-p t-c f-w-700" @click="edit(a)">{{a.agency}}</td>
                            <td class="ellipsis c-p t-c f-w-700" @click="edit(a)">{{a.number}}</td>
                            <td class="p-r o-x-h">
                                <div class="c-p ellipsis t-c" @click="edit(a)">{{a.is_default ? 'Sim' : 'Não'}}</div>
                                <div class="actions btn-group btn-group-xs">
                                    <button type="button"
                                            class="btn btn-danger btn-xs"
                                            @click="destroy(idx)"
                                            title="Remover">
                                        <svg-icon icon="trash-alt"/>
                                    </button>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div v-else class="grid-mobile" v-for="(a,idx) in entity.customer_accounts_attributes">
            <span class="bank">{{a.bank.code}} - {{a.bank.name}}</span>
            <span class="agency"><span class="label">Agência</span>{{a.agency}}</span>
            <span class="number"><span class="label">Conta</span>{{a.number}}</span>

            <div class="act">
                <button type="button"
                        class="btn btn-sm"
                        title="Modificar"
                        @click="edit(a)">
                    <svg-icon icon="pencil-alt"/>
                </button>

                <button type="button"
                        class="btn btn-sm"
                        title="Remover"
                        @click="destroy(idx)">
                    <svg-icon icon="trash-alt"/>
                </button>
            </div>
        </div>

        <div class="t-r">
            <button type="button"
                    @click="add"
                    style="margin-right: 10px"
                    class="btn btn-sm btn-outline-primary"
            ><svg-icon icon="plus"/> Adicionar</button>
        </div>
    </div>

</template>

<script>
    import {Bank} from "@/model";

    export default {
        name: "AccountsTab",
        props: {
            entity: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                banks: [],
                errors: {},
                bankAccount: null
            }
        },
        methods: {
            edit(account) {
                this.bankAccount = {...account};
            },
            destroy(idx) {
                this.$store.commit('addModal', {
                    title: this.$t('common.destroyItemTitle'),
                    size: 'small',
                    body: this.$t('common.destroyItemMessage'),
                    buttons: [{
                        type: 'ok', class: 'btn btn-danger btn-sm',
                        method: id => {
                            this.$store.commit('destroyModal', id);
                            const account = this.entity.customer_accounts_attributes[idx];

                            if (account.id) {
                                this.$appHttp.delete(`/v1/customers/destroy_account/${account.id}`)
                                    .then(() => {
                                        this.$snotify.success(this.$t('common.destroyItemSuccess'), this.$appStorage.getUser().name);
                                        this.$delete(this.entity.customer_accounts_attributes, idx);
                                        this.$emit('onUpdateTabBadges');
                                    })
                                    .catch(err => {
                                        this.$appUtils.vibrate();
                                        this.$snotify.error(this.$t('common.tryContactSupport', {msg: 'Ops... Aconteceu algum problema para tentar remover a conta bancária...'}), this.$appStorage.getUser().name);
                                        console.error(err);
                                    })
                            } else {
                                this.$delete(this.entity.customer_accounts_attributes, idx);
                                this.$emit('onUpdateTabBadges');
                            }
                        }
                    }, {
                        type: 'close', label: 'Não', focus: true, method: id => this.$store.commit('destroyModal', id)
                    }]
                });
            },
            add() {
                this.bankAccount = {
                    bank_id: this.banks[0].id,
                    bank: this.banks[0],
                    is_default: true,
                    _id: this.$appUtils.makeRandomId()
                }
            },
            save() {
                this.errors = {};

                if (!this.bankAccount.bank_id) {
                    this.$set(this.errors, 'bank_id', ['Campo obrigatório']);
                }

                if (this.$appUtils.isEmpty(this.bankAccount.agency)) {
                    this.$set(this.errors, 'agency', ['Campo obrigatório']);
                }

                if (this.$appUtils.isEmpty(this.bankAccount.number)) {
                    this.$set(this.errors, 'number', ['Campo obrigatório']);
                }

                if (Object.keys(this.errors).length === 0) {

                    for (let b of this.banks) {
                        if (b.id === this.bankAccount.bank_id) {
                            this.$set(this.bankAccount, 'bank', b);
                            break;
                        }
                    }

                    if (this.bankAccount.is_default)
                      this.entity.customer_accounts_attributes.forEach(e => e.is_default = false)

                    this.entity.customer_accounts_attributes.pushOrChange(this.bankAccount);

                    this.bankAccount = null;

                    this.$emit('onUpdateTabBadges');
                }
            }
        },
        mounted() {
            Bank.all()
                .then(b => this.banks = b);
        }
    }
</script>
<style lang="scss" scoped>
    .grid-mobile {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-areas: 'bank bank' 'agency number' 'act act';
        grid-template-rows: auto;
        grid-gap: 5px;
        padding: 5px;

        &:not(:first-child) {
            border-top: 1px solid #e7eaec;
        }

        .label {
            display: block;
            font-weight: bold;
            font-size: .8em;
        }

        .bank {
            text-align: center;
            grid-area: bank
        }

        .agency {
            grid-area: agency;
        }

        .number {
            grid-area: number;
            text-align: right;
        }

        .act {
            grid-area: act;
            text-align: right;

            .btn {
                background-color: #e5e5e5;
                svg {
                    color: #000;
                }
            }

            .btn:not(:last-child) {
                margin-right: 5px;
            }
        }
    }
</style>
